export class ChartB2BB2CPData {
  public constructor (
    readonly year: string,
    readonly privateAddress: string,
    readonly sum: string,
  ) {}

  static createListFromResponse (data: any): Array<ChartB2BB2CPData> {
    return data.map((item: any) => {
      return new ChartB2BB2CPData(
        item.Jahr,
        item.Privatadresse,
        item.Sum_Prozent
      )
    })
  }
}